import { axiosInstance } from "./config";

export default {
  state: {
    quality_section: {},
  },
  mutations: {
    Set_quality_section(state, payload) {
      state.quality_section = payload;
    },
  },
  actions: {
    async Get_quality_section({ commit }, payload) {
      if (!payload) {
        payload = "";
      } else {
        payload = "/" + payload;
      }
      return await axiosInstance
        .get(`/quality_section${payload}`)
        .then(function (data) {
          commit("Set_quality_section", data?.data?.data);
          return data?.data?.data;
        })
        .catch(function (error) {
          return {
            error: error?.response?.data?.message,
          };
        });
    },
    async Post_quality_section(commit, payload) {
      const formData = new FormData();
      formData.append("_method", "POST");
      for (const key in payload) {
        if (
          Object.prototype.hasOwnProperty.call(payload, key) &&
          payload[key] !== undefined
        ) {
          formData.append(key, payload[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/quality_section", formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Put_quality_section(commit, payload) {
      let payload2 = { ...payload };
      payload2.id = undefined;
      const formData = new FormData();
      formData.append("_method", "PUT");
      for (const key in payload2) {
        if (
          Object.prototype.hasOwnProperty.call(payload2, key) &&
          payload2[key] !== undefined
        ) {
          formData.append(key, payload2[key]);
        }
      }

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };
      return await axiosInstance
        .post("/quality_section/" + payload.id, formData, config)
        .then(function (data) {
          return data?.data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
    async Delete_quality_section(commit, payload) {
      return await axiosInstance
        .delete("/quality_section/" + payload.id)
        .then(function (data) {
          return data;
        })
        .catch(function (error) {
          return {
            error: error,
          };
        });
    },
  },
  getters: {
    g_quality_section: (state) => state.quality_section,
  },
};
